import workspaceQuery from 'graphql/queries/vat/VatAuthorityWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/vat/VatAuthorityListQuery.graphql';
import instanceQuery from 'graphql/queries/vat/VatAuthorityQuery.graphql';
import defaultQuery from 'graphql/queries/vat/VatAuthorityDefault.graphql';
import mutationQuery from 'graphql/mutations/vat/VatAuthorityMutation.graphql';
import fragment from 'graphql/fragments/vat/VatAuthorityFragment.graphql';

const VatAuthority = {
  type: 'VatAuthority',
  title: 'VAT Authorities',
  formTitle: 'VAT Authority',
  formUrl: '/Vat/Authority/Details/',
  workspaceUrl: '/Vat/Authority/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'description',
  },
  fragment,
  screenReference: 'VAT_AUTHORITIES',
};

export default VatAuthority;
